import type { Teammate } from "@repo/app-types/entities/teammate";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { TeammateAvatar } from "./teammateAvatar.js";

export interface TeammateAvatarPileProps {
  className?: string;
  teammates: readonly (Teammate | null | undefined)[];
}

export const TeammateAvatarPile: FC<TeammateAvatarPileProps> = (props) => {
  const { teammates } = props;

  return (
    <div
      className={twMerge("flex shrink-0 flex-row -space-x-2", props.className)}
    >
      {teammates.map((teammate, index) => (
        <TeammateAvatar key={teammate?.id ?? index} teammate={teammate} />
      ))}
    </div>
  );
};
